/**
 * Shared color mapping utilities for Shopify product swatches.
 */

/** Shopify option value (lowercase) → hex */
export const COLOR_HEX: Record<string, string> = {
  green: "#5C7C4D",
  "sea green": "#5C7C4D",
  "light yellow": "#F3E6A1",
  "baby yellow": "#F3E6A1",
  yellow: "#F3E6A1",
  burgundy: "#6D1F3A",
  "burgundy raisin": "#5a1a2e",
  "burgundy red": "#7a1b2e",
  "light blue": "#A9D6F5",
  "baby blue": "#A9D6F5",
  white: "#F5F5F5",
  ivory: "#F5F5F5",
  black: "#111111",
  beige: "#d4c5a9",
  grey: "#9e9e9e",
  red: "#c0392b",
  "hot pink": "#e91e8e",
  "blush pink": "#e8b4b8",
  blush: "#e8b4b8",
  pink: "#e898b0",
  "lipstick pink": "#d4456a",
  "bubble gum pink": "#f5a0c0",
  "bubble gum": "#f5a0c0",
  "electric blue": "#0056b3",
  "royal blue": "#2a5da8",
  blue: "#3b6fa0",
  "navy blue": "#1a2744",
  navy: "#1a2744",
  "neon lime": "#b8e233",
  bronze: "#8b6914",
  golden: "#c4a44a",
  gold: "#c4a44a",
  "olive gold": "#8b8b3a",
  silver: "#c0c0c0",
  brown: "#6b4226",
  "chocolate brown": "#4a2c17",
  chocolate: "#4a2c17",
  "pistachio green": "#93c572",
  pistachio: "#93c572",
  orange: "#d4742c",
  "organza pink": "#f0c0d0",
  rose: "#d4869c",
  lilac: "#c8a2c8",
  "emerald green": "#50C878",
  denim: "#4a6a8a",
  "light denim": "#6a8aaa",
  "dark denim": "#3a5a7a",
  mixed: "#7a8a7a",
};

/** Light hex values that need a visible border */
export const LIGHT_COLORS = new Set([
  "#F5F5F5",
  "#F3E6A1",
  "#d4c5a9",
  "#f5f0e0",
  "#f0c0d0",
  "#c0c0c0",
  "#c8a2c8",
]);

/** Pre-sorted keys (longest first) for greedy matching */
const SORTED_KEYS = Object.keys(COLOR_HEX).sort((a, b) => b.length - a.length);

/**
 * Map a raw color name to a hex value via greedy substring match.
 */
export function colorNameToHex(name: string): string | null {
  const lower = name.toLowerCase();
  for (const key of SORTED_KEYS) {
    if (lower.includes(key)) return COLOR_HEX[key];
  }
  return null;
}
